import * as ActionTypes from "../Types/ActionTypes";

export const CaseCount = (
  state = {
    isLoading: true,
    errMess: null,
    caseCount: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_CASE_COUNT:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        caseCount: action.payload,
      };

    case ActionTypes.CASE_COUNT_LOADING:
      return { ...state, isLoading: true, errMess: null, caseCount: [] };

    case ActionTypes.CASE_COUNT_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        caseCount: [],
      };

    default:
      return state;
  }
};